import "../../../callout.js";
import "../../../mixins/recoverable_error.js";
import "../../../field.js";
import "../fields/visit_type_select_field.js";
import "../fields/slot_field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.EditAppointmentCallout = class EditAppointmentCallout extends (
  AppointmentBooking.Wizard.Views.Mixins.RecoverableError(AppointmentBooking.Wizard.Views.Callout)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.resetShownByUser = this.resetShownByUser.bind(this);
    this.isShownByUser = this.isShownByUser.bind(this);
    this.toggleByUser = this.toggleByUser.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.visitTypeField = new AppointmentBooking.Wizard.Views.ConfirmationStep.VisitTypeSelectField({
      model: this.model,
      condition: () => this.model.get("validated_visit_types").length,
    });

    return (this.slotField = new AppointmentBooking.Wizard.Views.ConfirmationStep.SlotField({
      model: this.model,
      condition: () =>
        // A suggester will show instead of this field if there is no selected slot
        this.model.get("validated_ehr_appointment_slot_id"),
    }));
  }

  // RENDERING

  render() {
    super.render(...arguments);

    this.replaceContents(".visit-type-field-container", this.visitTypeField.render().el);
    this.replaceContents(".slot-field-container", this.slotField.render().el);

    return this;
  }

  resetShownByUser() {
    return (this.shownByUser = false);
  }

  isShownByUser() {
    return this.shownByUser;
  }

  toggleByUser() {
    this.toggle();
    return (this.shownByUser = this.visible);
  }
};
AppointmentBooking.Wizard.Views.ConfirmationStep.EditAppointmentCallout.prototype.template =
  "step/confirmation/callouts/edit_appointment";
AppointmentBooking.Wizard.Views.ConfirmationStep.EditAppointmentCallout.prototype.className =
  "appointment-booking-wizard-confirmation-step-edit-appointment-callout";

AppointmentBooking.Wizard.Views.ConfirmationStep.EditAppointmentCallout.prototype.recoverableErrorTypes = [
  "base_epic_invalid_date_error",
  "base_epic_make_fail_error",
  "ehr_appointment_slot_id_slot_taken",
  "ehr_appointment_slot_id_slot_expired",
];
